<template>
    <div class="main_center">
        <div class="content">
            <searchBox
                    :dialogVisible.sync="moreSearchItem"
                    @dialogCancle="dialogCancle"
                    title="更多筛选">
                <div class="search-drawer">
                    <el-form :model="form" label-position="top" ref="form">

                        <el-form-item label="组织机构名称：">
                            <el-input clearable placeholder="请输入内容搜索" v-model="form.orgName"></el-input>
                        </el-form-item>
                        <el-form-item label="部门名称：">
                            <el-select clearable filterable multiple placeholder="请选择"
                                       v-model="form.handleOrgName">
                                <el-option :key="item.data.id" :label="item.data.deptName" :value="item.data.id"
                                           v-for="item in departmentOptions">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="人员名称：">
                            <el-input clearable placeholder="请输入内容搜索" v-model="form.handleUserName"></el-input>
                        </el-form-item>
                        <el-form-item label="统计时间：">
                            <el-date-picker
                                    end-placeholder="结束日期"
                                    format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    style="width: 100%"
                                    type="daterange"
                                    v-model="datetimerange"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="数据所属部门：">
                        <select-depart-tree 
                            ref="selectDepartTreeRef"
                            :type="'2'"
                            :modelValue.sync="form.superviseDeptCodeList"  
                            :isMultiple="true" 
                            @handleDeptType="(val)=>changeDept(val,'5')" >
                            </select-depart-tree>
                        </el-form-item>
                    </el-form>
                    <div class="search-drawer__footer">
                        <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
                        <el-button @click="refresh" plain size="small">重置</el-button>
                    </div>
                </div>
            </searchBox>
            <div class="search-content">
                <div class="mainBtn">
                    <el-button @click="exportTable" plain  size="small" type="primary">导出</el-button>
                </div>
                <div class="searchBtn">
                    <span class="label-form">组织机构名称：</span>
                    <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 300px" v-model="form.orgName"></el-input>
                    <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
                    <el-button @click="moreSearchItem = true" icon="el-icon-arrow-down" size="mini" type="text">更多搜索</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
                </div>
            </div>
            <el-table :data="tableData"
                      class="table-content"
                      v-loading="dataListLoading"
                      @sort-change="sortChange"
                      :header-cell-style="this.$globalGrayTableHeaderStyle"
                      ref="multipleTable"
                      :height="tableMaxHeight" stripe border>
                <el-table-column
                        fixed
                        type="index"
                        align="center"
                        label="序号"
                        width="60"
                        :index="getRowsIndex">
                </el-table-column>
                <el-table-column align="left" header-align="center" label="所属组织机构名称" prop='handleOrgName' width='200'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="所属部门名称" min-width='120' prop='handleDeptName'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="办结人员姓名" min-width='120' prop='handleUserName'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="参与办结项目(宗标段)" min-width='160' prop='bidCount'
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{scope.row.bidCount + '宗'}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="办结次数" min-width='120' prop='finishCount' sortable
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{scope.row.finishCount + '次'}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="超时次数" min-width='120' prop='timeoutCount' sortable
                                 :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                        <span>{{scope.row.timeoutCount + '次'}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" header-align="center" label="超时率" min-width='120' prop='timeoutRate' sortable
                                 :show-overflow-tooltip='true'>
<!--                    <template slot-scope="scope">-->
<!--                        <span>{{scope.row.timeoutRate + '%'}}</span>-->
<!--                    </template>-->
                </el-table-column>
                <el-table-column align="center" header-align="center" label="平均超时时长" min-width='130' prop='averageTimeout' sortable
                                 :show-overflow-tooltip='true'>
<!--                    <template slot-scope="scope">-->
<!--                        <span>{{scope.row.averageTimeout?(scope.row.averageTimeout + '分钟'):'-'}}</span>-->
<!--                    </template>-->
                </el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="routerDetail(scope.row,'detail')">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
                           layout="total, sizes, prev, pager, next"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           :current-page="pageIndex"
                           @size-change="sizeChangeHandle"
                           @current-change="currentChangeHandle"></el-pagination>
        </div>
        <detailList
                ref="detailListRef"
                :dialogVisible.sync="detailListDialog">
        </detailList>
    </div>
</template>

<script>
    // import {removeTabHandle} from '@/utils/routeTab';
    import detailList from "./detailList";
    import selectDepartTree from "@/views/modules/components/selectDepartTree"
import { mapState } from "vuex";
    export default {
        name: "busWitnessTable",
        components: {
            detailList,
            selectDepartTree
        },
        data(){
            return {
                tableMaxHeight: document.documentElement.clientHeight - 300 ,
                dataListLoading: false,
                detailListDialog:false,
                departmentOptions:[],
                datetimerange:[],
                form: {
                    orgName:'',
                    handleOrgName:'',
                    handleUserName:'',
                    superviseDeptCodeList:[],
                },
                sortParams: {
                    order:'',
                    prop:''
                },
                groupMark:'',
                flownodesListData:[],
                moreSearchItem: false,
                checkList1: '',
                pageSize: 10,//每页条数
                pageIndex: 1,//当前页
                total: 0,//总条数
                tableData: [],
                multipleSelection: [],
                user: '', //角色类型
                formData: {}
            }
        },
        filters:{
            ellipsis(text, num) {
                if (text.length > num) {
                    return text.substring(0, num) + '...';
                } else {
                    return text;
                }
            },

        },
        watch:{
        uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){this.getDataList()}
                }
            }
        },
        computed: {
            ...mapState({
            uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
        })
        },
        created(){
            this.getSelectData();
        },
        activated(){
            this.getDataList()
        },
        mounted() {

            const that = this;
            let resizeTag = true;
            window.onresize = () => {
                if(resizeTag) { //防抖动
                    that.ifmove();
                    resizeTag = false
                    setTimeout(() => {
                        resizeTag = true
                    }, 1000)
                }
            }
            that.ifmove();
        },
        computed:{
            ...mapState({
            isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
        }),
        },
        methods:{
            changeDept(val,str){//切换部门
            this.form.superviseDeptCodeList=[]
                   if(str==='5'){
                    // 多选
                     val.forEach((item,index)=>{
                        if( item.type!=="region"){
                           this.form.superviseDeptCodeList.push(item.code)
                        }
                    })
                    }
        },
            getSelectData() {
                this.$httpReq({
                    url: `/configs/sysexectormanage/listDepartment`,
                    method: 'get',
                }).then(({ data }) => {
                    if (data.code == 1) {
                        this.departmentOptions = data.data;
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },
            dialogCancle(){
                this.moreSearchItem = false
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },

            ifmove() {
                let tableMaxHeight = document.documentElement.clientHeight - 227;
                this.pageSize = parseInt((tableMaxHeight) / 50 ) || 1;
                this.$nextTick(() => {
                    this.tableMaxHeight = tableMaxHeight
                })
            },
            sortChange(column, prop, order){
                this.sortParams.prop = prop || column.prop;
                this.sortParams.order = order || column.order;
                this.getDataList();
            },
            getDataList() { // 获取列表数据

                this.dataListLoading=true;
                this.form.statisticTimeGE = this.datetimerange[0]?this.datetimerange[0]:"";
                this.form.statisticTimeLT = this.datetimerange[1]?this.datetimerange[1]:"";
                this.form.superviseDeptCodeList= (this.form.superviseDeptCodeList || []).length==0?this.uerdefultOptionCode:this.form.superviseDeptCodeList
                this.$httpReq.post('/businessflowstatistic/list', {
                    'page': this.pageIndex,
                    'rows': this.pageSize,
                    'orderBy':(this.sortParams.prop && this.sortParams.order)?(this.sortParams.prop + (this.sortParams.order == "ascending"?' asc':' desc')):"",
                    'filter': {
                        orgName:this.form.orgName,
                        handleOrgName:this.form.handleOrgName,
                        handleUserName:this.form.handleUserName,
                        statisticTimeGE:this.form.statisticTimeGE,
                        statisticTimeLT:this.form.statisticTimeLT,
                        superviseDeptCodeList:this.form.superviseDeptCodeList
                    }
                }).then(res => {
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                    this.$refs.multipleTable.doLayout();
                    this.dataListLoading = false;
                })
            },

            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1
                this.getDataList()
            },
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getDataList()

            },

            indexMethod(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            exportTable(){
              this.$httpReq({
                method:'post',
                url:'/businessflowstatistic/export',
                responseType:'blob',
                data: {
                  'page': 1,
                  'rows': 1000,
                  'orderBy':(this.sortParams.prop && this.sortParams.order)?(this.sortParams.prop + (this.sortParams.order == "ascending"?' asc':' desc')):"",
                  'filter': {
                    orgName:this.form.orgName,
                    handleOrgName:this.form.handleOrgName,
                    handleUserName:this.form.handleUserName,
                    statisticTimeGE:this.form.statisticTimeGE,
                    statisticTimeLT:this.form.statisticTimeLT
                  }
                }
              }).then(res => {
                    const objectUrl = URL.createObjectURL(res.data);
                    let downloadLink = document.getElementById('downloadLink');
                    if (!downloadLink) {
                        downloadLink = document.createElement('a');
                        downloadLink.setAttribute('id', 'downloadLink');
                        downloadLink.setAttribute('style', 'display:none');
                        document.body.appendChild(downloadLink);
                    }
                    downloadLink.setAttribute('download', '统计数据.xls');
                    downloadLink.setAttribute('href', objectUrl);
                    downloadLink.click();
                    URL.revokeObjectURL(objectUrl);
                })


            },
            //搜索按钮
            searchBtn(){
                this.pageIndex=1;
                this.getDataList()
            },
            refresh() {//刷新按钮
                this.pageIndex = 1;
                this.form.orgName = "";
                this.form.handleOrgName = "";
                this.form.handleUserName = '';
                this.form.superviseDeptCodeList=[]
                   // 重置默认所属数据
                if( this.$refs.selectDepartTreeRef){
                    this.$refs.selectDepartTreeRef.getUserTreeOption()
                }
                this.getDataList()
            },


            routerDetail(item){ // 跳转详情
                this.detailListDialog = true;
                this.$refs.detailListRef.getDataList(this.statisticTimeGE,this.statisticTimeLT,item.handleOrgId,item.handleUserId);
            },

        },

        destroyed(){
            window.onresize = null;
        },




    }
</script>
<style lang="scss" scoped>

    //列表页面
    .main_center{
        /deep/ .el-dialog__body{
            padding-top: 0px;
        }
    }

</style>
